import React from 'react';
import styles from '../flabernardi_/flabernardi_.module.scss';
import Background from './src/background-links.png';
import LinkPersonalizado7 from '../../components/LinkPersonalizado7/linkPersonalizado7.tsx';
import InstagramIcon from '../../icons/instagramIcon.tsx';
import MapsIcon from '../../icons/mapsIcon.tsx';
import WhatsappIcon from '../../icons/whatsappIcon.tsx';
import HouseIcon from '../../icons/houseIcon.tsx';
import PartnershipIcon from '../../icons/partnershipIcon.tsx';
import MakeIcon from '../../icons/makeIcon.tsx';
import CatalogIcon from '../../icons/catalogIcon.tsx';

const Flabernardi_: React.FC = () => {
    return (
        <div className={styles.flabernardi_}>
            <div className={styles['body-thunder']}>
                <img
                    src={Background}
                    alt="Flávia de Oliveira Bernardi"
                    className={styles.heroImage}
                />
                <div className={styles.content}>
                    <div className={styles['container-thunder']}>
                        <h1 className="pt-2">Flávia de Oliveira Bernardi</h1>
                        <div className={styles['redes-sociais']}>
                            <div>
                                <a
                                    href="https://www.instagram.com/flabernardi_?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    <InstagramIcon height="22" color="#C6A77B" />
                                </a>
                                <a
                                    href="https://maps.app.goo.gl/s4fbPSz8z1UBPasv8"
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    <MapsIcon height="27" color="#C6A77B" />
                                </a>
                                <a href="https://wa.me/5517981381550" target="_blank" rel="noreferrer">
                                    <WhatsappIcon height="28" color="#C6A77B" />
                                </a>
                            </div>
                        </div>
                    </div>
                    <div className={styles.links}>
                        <LinkPersonalizado7
                            href="/flabernardi_/procedimentos"
                            linkInterno={true}
                            title={'PROCEDIMENTOS'}
                            spaceBetween={true}
                            icon={<CatalogIcon height="30" color="#3A2E2B" />}
                            colorText="#C6A77B"
                        />
                        <LinkPersonalizado7
                            href="https://wa.me/5517981381550?text=Olá, gostaria de mais informações sobre cursos/atendimentos."
                            title={'CURSOS\nATENDIMENTOS'}
                            spaceBetween={true}
                            icon={<MakeIcon height="30" width="30" color="#3A2E2B" />}
                            colorText="#C6A77B"
                        />
                        <LinkPersonalizado7
                            href="https://www.cmdimobiliario.com.br"
                            title={'CONSULTORIA\nIMOBILIÁRIA'}
                            spaceBetween={true}
                            icon={<HouseIcon height="30" color="#3A2E2B" />}
                            colorText="#C6A77B"
                        />
                        <LinkPersonalizado7
                            href="https://wa.me/5517981381550?text=Olá, gostaria de mais informações sobre parcerias."
                            title={'PARCERIAS'}
                            spaceBetween={true}
                            icon={<PartnershipIcon height="30" color="#3A2E2B" />}
                            colorText="#C6A77B"
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Flabernardi_;
